$(function () {
    initLoadMoreReplies();
});

function initLoadMoreReplies(el) {
    if(el != null){
        $('.load-more-replies-ajax', el).on('click', getMoreReplies);
    } else {
        $('.load-more-replies-ajax').on('click', getMoreReplies);
    }
}

function getMoreReplies(e) {
    e.preventDefault();
    
    var replyContainer = $(this).parents('.timeline-replies');

    $(this).fadeOut(); // hide the link itself, schould become visible again after ajax call has been loaded
    $('.timeline-reply-load-more-loading', $(this).parent()).fadeIn(); // show the loading animation
    $.get("/timeline/loadMoreReplies",
        {
            'reply_id': $('.timeline-reply:not(.timeline-reply-load-more)', replyContainer).first().attr('data-reply')
        },
        function (response) {
            if (response.success == true) {
                $.each(response.data.replies, function (key, reply) {
                    $('.timeline-reply:not(.timeline-reply-load-more)', replyContainer).first().before(reply);
                });
            } else {
                systemalert(response.message, 'warning');
            }
            if (response.data.hasMoreReplies) {
                $('.timeline-reply-load-more-loading', $(this).parent()).fadeOut(); // show the loading animation
                $(this).fadeIn(); // hide the link itself, schould become visible again after ajax call has been loaded
            } else {
                $('.timeline-reply-load-more', $(this).parent().fadeOut());
            }

        }
        .bind(this),
        'json'
    )
    .fail(function () {
        $(this).attr('disabled', false);
        systemalert('There was an system error, please notify an admin!', 'danger');
    });
}